import type { FC, ReactNode } from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';

export interface MenuItemData {
  id: string;
  path: string;
  label: string;
  isNew?: boolean;
  iconElement: ReactNode;
  isHightlighted?: boolean;
}

export const MenuItem: FC<{
  isSelected: boolean;
  data: MenuItemData;
  extra?: ReactNode;
}> = ({ data, isSelected, extra }) => {
  return (
    <div
      className={cn(
        'text-text700 hover:text-green700 relative flex h-[46px] py-[10px] transition duration-300 ease-in',
        {
          'text-green700': isSelected,
        }
      )}
      data-id={data.path}
      key={data.path}
    >
      {isSelected && (
        <div
          className="border-green700 absolute inset-0 h-full w-5 border-l-[2px]"
          style={{
            left: '-20px',
            backgroundImage:
              'linear-gradient(to right, rgba(36, 216, 150, 0.2), rgba(38, 227, 175, 0))',
          }}
        />
      )}
      {data.iconElement}
      <div className="relative flex flex-1 flex-col justify-center self-center pl-[14px] leading-none">
        <span
          className={cn('text-sm leading-none', {
            'font-semibold': data.isHightlighted,
          })}
          style={
            data.isHightlighted
              ? {
                  background:
                    'linear-gradient(90deg, #d67140, #e0a91b, #d67140) 0 0 / 400% 100%',
                  color: 'transparent',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                }
              : {}
          }
        >
          {data.label}
        </span>
        {extra}
      </div>
      {data.isNew && (
        <div className="text-blue700 bg-text800 absolute -right-2 self-end rounded px-[10px] py-1 text-center text-xs font-semibold">
          NEW
        </div>
      )}
      {data.isHightlighted && (
        <div
          className="bg-text800 absolute right-0 -mr-2 self-end rounded px-[10px] py-[2px] text-center text-xs font-semibold text-[#fcfcfc]"
          style={{
            background: 'linear-gradient(to right, #d67140, #e0a91b)',
            textShadow: '1px 1px 2px #000000',
          }}
        >
          NEW
        </div>
      )}
    </div>
  );
};

export const Menu = ({ children }: { children: ReactNode }) => {
  return (
    <div className="bg-back600 text-text700 flex w-full flex-col">
      {children}
    </div>
  );
};
